import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

// ✅ Fetch Doctor Profile Safely
export const fetchDoctorProfile = createAsyncThunk(
  "profile/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/doctors/profile/");
      return response.data; // ✅ API now returns a single object
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch profile");
    }
  }
);

// ✅ Update Doctor Profile
export const updateDoctorProfile = createAsyncThunk(
  "profile/update",
  async (profileData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("/doctors/profile/", profileData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update profile");
    }
  }
);

// ✅ Upload Verification Documents
export const uploadDocuments = createAsyncThunk(
  "profile/uploadDocuments",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/doctors/profile/upload-document/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to upload documents");
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState: { data: null, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctorProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDoctorProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchDoctorProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateDoctorProfile.fulfilled, (state, action) => {
        state.data = action.payload;
      })
      .addCase(uploadDocuments.fulfilled, (state, action) => {
        state.data.verification = action.payload;
      });
  },
});

export default profileSlice.reducer;
